import React from 'react';
import type { ComponentProps } from 'react';
import styled from '@emotion/styled';
import { color, space } from 'styled-system';
import type { ColorProps, SpaceProps } from 'styled-system';

import BaseCountDown from 'common/components/CountDown';
import { useLocalization } from 'common/providers/LocaleProvider';
import type { BannerProps } from '../../../types';

type CountDownProps = {
  textColor?: BannerProps['textColor'];
  countdownEndDate?: BannerProps['countdownEndDate'];
};

const InnerCountDown = styled(BaseCountDown)<SpaceProps & ColorProps>`
  ${space};
  ${color};
`;

const innerCountDownStyles: Partial<ComponentProps<typeof InnerCountDown>> = {
  m: 'sp_0',
  pt: 'sp_0',
};

const CountDown = ({ textColor, countdownEndDate }: CountDownProps) => {
  const { t } = useLocalization();

  if (!countdownEndDate) return null;

  return (
    <InnerCountDown
      {...innerCountDownStyles}
      color={textColor ?? 'sys.neutral.text.strong'}
      endDate={countdownEndDate}
      label={t('h24_countdown_banner_label')}
    />
  );
};

export default CountDown;
